export const CONDITIONS_TABLE = {
  content: [
    'DIABETES',
    'HIGH CHOLESTEROL',
    'HIGH TRIGLYCERIDES',
    'HEADACHES',
    'GALLBLADDER PROBLEMS',
    'KIDNEY PROBLEMS',
    'HISTORY OF DEPRESSION',
    'HIGH BLOOD PRESSURE',
  ],
  footnote: (
    <p data-qa-tag="nexplanon-footnote" className='body-text'>
      Before getting NEXPLANON, please tell the trained healthcare professional if you have any allergies to numbing medicines or antiseptics used to clean your skin. These medicines will be used when the implant is placed into or removed from your arm.
    </p>
  ),
};
